<script>
export default {
  name: 'MenuItem',
  functional: true,
  props: {
    icon: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: '',
    },
    resourceKey: {
      type: String,
      default: '',
    },
    routeInfo: {
      type: Object,
      default: () => ({}),
    },
    indexNum: {
      type: Number,
      default: () => 0,
    },
  },
  render(h, context) {
    const { icon, title, resourceKey, routeInfo, indexNum } = context.props
    const { hasFunc, extra } = routeInfo || {}
    const vnodes = []

    if (icon) {
      if (icon.startsWith('el-icon') || icon.startsWith('BLM-icon')) {
        vnodes.push(<i class={icon} style="margin-right: 16px;width: 14px;font-size: 14px;"></i>)
      } else {
        vnodes.push(<svg-icon icon-class={icon}/>)
      }
    }

    const content = title && title.length > (10 - indexNum)
      ? (
        <el-tooltip content={title} placement="right">
          <span class="item-text">{(title)}</span>
        </el-tooltip>
      )
      : (<span class="item-text">{(title)}</span>)

    if (title) {
      vnodes.push(
        <span slot="title" data-sourceKey={resourceKey} class="has-bragger-item">
          {content}
          {hasFunc && extra && extra.value ? (<span class="bragger">{extra.value}</span>) : ''}
        </span>,
      )
    }
    return vnodes
  },
}
</script>
